import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LoginGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean {
    const loginCompleto = localStorage.getItem('login_completo');

    if (loginCompleto === 'true') {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}